/**
 * FE#444 — "what does the plan say about creating N copies right now?", read straight from the
 * store. The dialog (to disable Schedule and explain) and the thunk (to refuse) call this ONE
 * function, so what the user is shown and what is enforced cannot disagree.
 *
 * NOTE: this is a client-side gate and nothing more. The compose dialog's wall is a UI gate as well;
 * the copies go through the same create path, so there is no separate server-side check to lean on.
 */
import { selectScheduleSlotsUsed } from '@common-reducers/UserMessageSelectors';
import { messageLimitSelector, scheduleEntitlementSelector, selectUserId } from '@common-reducers/UserSelectors';
import { deriveBulkScheduleVerdict, type BulkScheduleVerdict } from '@common-reducers/free-limit-gate';
import { selectFreeLimitPolicy, selectFreeLimitSettled } from '@common-reducers/free-limit-slice';
import type { CommonRootState } from '@common/types/common-root-state-type';

export function planVerdictFor(state: CommonRootState, copies: number): BulkScheduleVerdict {
    return deriveBulkScheduleVerdict({
        hasIdentity: !!selectUserId(state),
        freeLimitSettled: selectFreeLimitSettled(state),
        entitlementUnknown: scheduleEntitlementSelector(state) === 'unknown',
        slotsUsed: selectScheduleSlotsUsed(state),
        count: copies,
        paidUnlimited: messageLimitSelector(state) === Infinity,
        policy: selectFreeLimitPolicy(state),
    });
}
